/**
 * Flatten the rows of POST /v2/b2b/external-orders/paginated for the list. The route nests the
 * joined entities (`externalClient`, `store`, `channel`), while ListView reads and sorts on a flat
 * `propertyKey` named after the `orderBy` keys the same route accepts.
 *
 * @param {Array<Object>} externalOrders - The rows returned by the list route
 *
 * @returns {Array<Object>} The rows the columns expect
 */
export const formatExternalOrders = (externalOrders) =>
  externalOrders.map(
    ({
      id,
      reference,
      externalClient,
      store,
      deliveryDate,
      deliveryTime,
      channel,
      status,
      totalWithTaxes,
    }) => ({
      id,
      reference,
      externalClientId: externalClient?.id ?? null,
      externalClientName: externalClient?.name ?? null,
      storeId: store?.id ?? null,
      storeName: store?.name ?? null,
      deliveryDate,
      deliveryTime,
      channelId: channel?.id ?? null,
      channelName: channel?.name ?? null,
      channelTranslationKey: channel?.translationKey ?? null,
      status,
      totalWithTaxes,
    }),
  );
